export default {
  pages: {
    data: [],
    meta: {
      total: 0,
      per_page: 20,
      current_page: 1,
      last_page: 1
    }
  },
  activePages: [],
  currentPage: null,
  defaultPage: null,
  loading: false
}
